import { render, staticRenderFns } from "./OrticInlineEdit.vue?vue&type=template&id=65bd6b36&"
import script from "./OrticInlineEdit.vue?vue&type=script&lang=js&"
export * from "./OrticInlineEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports